// Test IDs for the customer account (OAuth PKCE) surfaces.
// See ./index.js for the recipe when adding new features.

export const ACCOUNT = {
        // Header (signed-out)
        headerAccountLink: 'account-header-link',
        // Header (signed-in)
        headerGreeting: 'account-header-greeting',
        headerDropdownToggle: 'account-header-dropdown-toggle',
        headerDropdownMenu: 'account-header-dropdown-menu',
        headerAccountItem: 'account-header-item-account',
        headerOrdersItem: 'account-header-item-orders',
        headerSignOutItem: 'account-header-item-sign-out',
        // /account/login
        loginPage: 'account-login-page',
        loginPrimaryCta: 'account-login-primary-cta',
        loginFallbackLink: 'account-login-fallback-link',
        // /account/index
        indexPage: 'account-index-page',
        indexGreeting: 'account-index-greeting',
        indexEmail: 'account-index-email',
        indexOrdersLink: 'account-index-orders-link',
        indexSignOutButton: 'account-index-sign-out-button',
        // /account/logout
        logoutPage: 'account-logout-page',
        // Orders panel (PROMPT 2.7-B)
        ordersPanel: 'account-orders-panel',
        ordersLoading: 'account-orders-loading',
        ordersEmpty: 'account-orders-empty',
        ordersList: 'account-orders-list',
        orderRow: 'account-order-row',
        orderRowName: 'account-order-row-name',
        orderRowStatus: 'account-order-row-status',
        orderRowTotal: 'account-order-row-total',
        cancelRequestButton: 'account-order-cancel-request-btn',
        cancelAlreadyRequestedLabel: 'account-order-cancel-already-label',
        cancelDispatchedLabel: 'account-order-cancel-dispatched-label',
        cancelConfirmModal: 'account-cancel-confirm-modal',
        cancelConfirmYes: 'account-cancel-confirm-yes',
        cancelConfirmNo: 'account-cancel-confirm-no',
        cancelSuccessToast: 'account-cancel-success-toast',
};
